import WebinarsData from 'components/Events/WebinarNavbar'
import EventsList from 'components/Events/EventsList'
import Themes from 'components/Events/Themes'
import Speakers from 'components/Events/Speakers'
import FinancialClub from 'components/Events/FinancialClub'
import WebinarReviews from 'components/Events/WebinarReviews'

export default {
  children: [
    {
      path: 'webinars',
      name: 'WebinarsData',
      component: WebinarsData,
      children: [
        {
          path: 'themes',
          name: 'Webinars',
          component: Themes
        }, {
          path: 'speakers',
          name: 'Speakers',
          component: Speakers
        }, {
          path: 'reviews',
          name: 'Reviews',
          component: WebinarReviews
        }
      ]
    }, {
      path: 'club',
      name: 'FinancialClubs',
      component: FinancialClub
    }, {
      path: 'club/:id',
      name: 'FinancialClub',
      component: FinancialClub
    }, {
      path: 'list',
      name: 'EventsList',
      component: EventsList
    }, {
      path: 'list/:id',
      name: 'Events',
      component: EventsList
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/EventsRoutes.js